<template>
  <div id="profile-completedRevs" data-tourid="profile-sheet-completedRevs">
    <p
      class="subtitle2 font-weight-bold mx-0 pa-0"
      v-if="!isLoading && revs.length"
    >
      {{ $t('profile.last_completed_ideas') }}
    </p>

    <v-row v-if="!isLoading && revs.length" class="ma-0 pa-0">
      <v-col v-for="rev in revs" cols md="4" sm="6" :key="rev.id">
        <v-card
          outlined
          link
          class="card-hover my-2 d-flex flex-column"
          height="260px"
          :to="getRoute(rev.type, rev.id)"
        >
          <BackgroundImage
            data-private
            class="flex-grow-1"
            :size="IMAGE_SIZES.CARD"
            :mediaObject="rev.image"
            :defaultImage="defaultImage"
          />
          <v-card-text class="flex-shrink-1">
            <EntityChip :entityType="rev.type" class="mb-2"></EntityChip>
            <p>
              {{ getTrimmedName(rev.name) }}
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <EmptyState
      v-if="!revs.length && !isLoading"
      id="profile-recentCollaborators"
      class="py-8 px-16"
      :icon="'mdi-bee'"
      :iconSize="48"
      :title="$t('profile.empty-revs-title')"
      :buttonSubtitle="
        isSelfProfile ? $t('profile.empty-revs-subtitle-self-profile') : null
      "
      :buttonText="isSelfProfile ? $t('common.create_rev') : null"
      @click="showCreateModal = true"
    />

    <v-row v-if="isLoading" class="py-4">
      <v-col>
        <v-skeleton-loader type="card" elevation="2"></v-skeleton-loader>
      </v-col>
      <v-col>
        <v-skeleton-loader type="card" elevation="2"></v-skeleton-loader>
      </v-col>
      <v-col>
        <v-skeleton-loader type="card" elevation="2"></v-skeleton-loader>
      </v-col>
    </v-row>

    <CreateContentModal
      v-if="showCreateModal"
      :show="showCreateModal"
      @close="showCreateModal = false"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import revMixin from '@/mixins/revMixin'
import { IMAGE_SIZES } from 'rever-media-sdk'
import defaultImage from '@/assets/images/camera_no.png'
import BackgroundImage from '@/components/BackgroundImage/BackgroundImage.vue'
import EntityChip from '@/components/EntityChip.vue'
import CreateContentModal from '@/components/CreateContentModal/CreateContentModal.vue'

import emptyStateImage from '@/assets/images/empty-states/icon-empty-state-bee.svg'
import EmptyState from '@/components/EmptyState.vue'

export default {
  name: 'CompletedRevs',

  mixins: [revMixin],

  components: {
    BackgroundImage,
    CreateContentModal,
    EntityChip,
    EmptyState,
  },

  props: {
    isLoading: {
      required: true,
      type: Boolean,
    },
    organizationId: {
      required: true,
      type: String,
    },
    revs: {
      required: true,
      type: Array,
    },
    isSelfProfile: {
      required: true,
      type: Boolean,
    },
  },

  data() {
    return {
      defaultImage,
      emptyStateImage,
      IMAGE_SIZES,
      showCreateModal: false,
    }
  },

  computed: {
    ...mapGetters(['organization']),
  },

  methods: {
    getTrimmedName(name) {
      if (name.length > 90) return `${name.substring(0, 90)}...`
      return name
    },

    getRevType(type) {
      return (
        this.organization?.customNamings[type]?.singular ||
        this.$t(`common.${_.snakeCase(type)}_one`)
      )
    },

    getRoute(type, revId) {
      return this.generateRevRoute(this.organizationId, type, revId)
    },
  },
}
</script>

<style lang="scss" scoped>
.empty-state-subtitle {
  margin: 0px 35%;
}
</style>
